import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export enum SiteVisitEmployeeRole {
	primary = 'primary'
}
export interface ISiteVisitEmployee extends IModel {
	siteVisitKey?: string;
	employeeKey?: string;
	role?: string;
}

const siteVisitEmployeeFactory = modelFactory.createFactory<ISiteVisitEmployee>('SiteVisitEmployee', _.assign({}, model, {
	siteVisitKey: {
		setFilters: valueFilters.clean
	},
	employeeKey: {
		setFilters: valueFilters.clean
	},
	role: {
		setFilters: valueFilters.clean,
		rules: validator.required(),
		defaultValue: SiteVisitEmployeeRole.primary
	}
}));

export default siteVisitEmployeeFactory;